<template>
  <v-app style="background-color:white;margin-top:140px">
     <go-top></go-top>
     <div style="padding-top:10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr">Home</span> / <span style="color:#7FB4FD">Our Team</span></p>
     </div>
     
     

     <div class="container">
         <h2 style="text-align:center;">Meet Our Professionals</h2>
         <p style="text-align:center;font-size:14px;" class="covid">When your mission is to be better, faster and smarter, you need the best people driving your</p>
         <p style="text-align:center;padding-bottom:30px;font-size:14px;" class="covid">vision forward.</p>
         

         <v-layout row wrap>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/GOURAB SIR.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Gourab Sarkar</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Founder</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/ANANYA MA'AM.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Ananya Sarkar</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Co - Founder</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/SRABANA MA'AM.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Srabana Bhattacharya</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Co - Founder</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/GARGI MA'AM.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Gargi Roy</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Co - Founder</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/TIYASA.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Tiyasa Sharma</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Vendor acquisition & HR Administration</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/JESSICA.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Jessica Gomes</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Customer Service</p>
             </v-flex>
             <!-- <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/DEVARSHI.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Devarshi Kar</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Logistics and delivery</p>
             </v-flex> -->
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/SUBHAJIT.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Subhajit Sarkar</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Digital marketing expert</p>
             </v-flex>
             <v-flex xs12 sm12 md3 style="padding:10px">
                 <img src="../../assets/BHASWAR.jpg" width="100%" style="border-radius:5px" />
                 <p style="text-align:center;padding-top:15px;font-size:17px;">Bhaswar Das</p>
                 <p style="text-align:center;margin-top:-15px;font-size:13px;" class="covid">Web designer</p>
             </v-flex>
         </v-layout>
     </div>
  </v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
import carousel from 'vue-owl-carousel';

export default {
  components: {
    GoTop,
    carousel
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      text: null,
      read: false,

      form: {},

      
    };
  },
  
   mounted() {
   },

 methods: {
     home(){
         this.$router.push(`/demo`);
     }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
</style>

<style scoped>
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #3486D7 !important;
}
</style>
